export enum Timezones {
  'Pacific/Niue' = 'Pacific/Niue',
  'Pacific/Pago_Pago' = 'Pacific/Pago_Pago',
  'Pacific/Honolulu' = 'Pacific/Honolulu',
  'Pacific/Rarotonga' = 'Pacific/Rarotonga',
  'Pacific/Tahiti' = 'Pacific/Tahiti',
  'Pacific/Marquesas' = 'Pacific/Marquesas',
  'America/Anchorage' = 'America/Anchorage',
  'Pacific/Gambier' = 'Pacific/Gambier',
  'America/Los_Angeles' = 'America/Los_Angeles',
  'America/Tijuana' = 'America/Tijuana',
  'America/Vancouver' = 'America/Vancouver',
  'America/Whitehorse' = 'America/Whitehorse',
  'Pacific/Pitcairn' = 'Pacific/Pitcairn',
  'America/Dawson_Creek' = 'America/Dawson_Creek',
  'America/Denver' = 'America/Denver',
  'America/Edmonton' = 'America/Edmonton',
  'America/Hermosillo' = 'America/Hermosillo',
  'America/Mazatlan' = 'America/Mazatlan',
  'America/Phoenix' = 'America/Phoenix',
  'America/Yellowknife' = 'America/Yellowknife',
  'America/Belize' = 'America/Belize',
  'America/Chicago' = 'America/Chicago',
  'America/Costa_Rica' = 'America/Costa_Rica',
  'America/El_Salvador' = 'America/El_Salvador',
  'America/Guatemala' = 'America/Guatemala',
  'America/Managua' = 'America/Managua',
  'America/Mexico_City' = 'America/Mexico_City',
  'America/Regina' = 'America/Regina',
  'America/Tegucigalpa' = 'America/Tegucigalpa',
  'America/Winnipeg' = 'America/Winnipeg',
  'Pacific/Galapagos' = 'Pacific/Galapagos',
  'America/Bogota' = 'America/Bogota',
  'America/Cancun' = 'America/Cancun',
  'America/Cayman' = 'America/Cayman',
  'America/Guayaquil' = 'America/Guayaquil',
  'America/Havana' = 'America/Havana',
  'America/Iqaluit' = 'America/Iqaluit',
  'America/Jamaica' = 'America/Jamaica',
  'America/Lima' = 'America/Lima',
  'America/Nassau' = 'America/Nassau',
  'America/New_York' = 'America/New_York',
  'America/Panama' = 'America/Panama',
  'America/Port' = 'America/Port',
  'America/Rio_Branco' = 'America/Rio_Branco',
  'America/Toronto' = 'America/Toronto',
  'Pacific/Easter' = 'Pacific/Easter',
  'America/Caracas' = 'America/Caracas',
  'America/Asuncion' = 'America/Asuncion',
  'America/Barbados' = 'America/Barbados',
  'America/Boa_Vista' = 'America/Boa_Vista',
  'America/Campo_Grande' = 'America/Campo_Grande',
  'America/Cuiaba' = 'America/Cuiaba',
  'America/Curacao' = 'America/Curacao',
  'America/Grand_Turk' = 'America/Grand_Turk',
  'America/Guyana' = 'America/Guyana',
  'America/Halifax' = 'America/Halifax',
  'America/La_Paz' = 'America/La_Paz',
  'America/Manaus' = 'America/Manaus',
  'America/Martinique' = 'America/Martinique',
  'America/Port_of_Spain' = 'America/Port_of_Spain',
  'America/Porto_Velho' = 'America/Porto_Velho',
  'America/Puerto_Rico' = 'America/Puerto_Rico',
  'America/Santo_Domingo' = 'America/Santo_Domingo',
  'America/Thule' = 'America/Thule',
  'Atlantic/Bermuda' = 'Atlantic/Bermuda',
  'Canada/Atlantic' = 'Canada/Atlantic',
  'America/St_Johns' = 'America/St_Johns',
  'America/Araguaina' = 'America/Araguaina',
  'America/Argentina' = 'America/Argentina',
  'America/Bahia' = 'America/Bahia',
  'America/Belem' = 'America/Belem',
  'America/Cayenne' = 'America/Cayenne',
  'America/Fortaleza' = 'America/Fortaleza',
  'America/Godthab' = 'America/Godthab',
  'America/Maceio' = 'America/Maceio',
  'America/Miquelon' = 'America/Miquelon',
  'America/Montevideo' = 'America/Montevideo',
  'America/Paramaribo' = 'America/Paramaribo',
  'America/Recife' = 'America/Recife',
  'America/Santiago' = 'America/Santiago',
  'America/Sao_Paulo' = 'America/Sao_Paulo',
  'Antarctica/Palmer' = 'Antarctica/Palmer',
  'Antarctica/Rothera' = 'Antarctica/Rothera',
  'Atlantic/Stanley' = 'Atlantic/Stanley',
  'America/Noronha' = 'America/Noronha',
  'Atlantic/South_Georgia' = 'Atlantic/South_Georgia',
  'America/Scoresbysund' = 'America/Scoresbysund',
  'Atlantic/Azores' = 'Atlantic/Azores',
  'Atlantic/Cape_Verde' = 'Atlantic/Cape_Verde',
  'Africa/Abidjan' = 'Africa/Abidjan',
  'Africa/Accra' = 'Africa/Accra',
  'Africa/Bissau' = 'Africa/Bissau',
  'Africa/Casablanca' = 'Africa/Casablanca',
  'Africa/El_Aaiun' = 'Africa/El_Aaiun',
  'Africa/Monrovia' = 'Africa/Monrovia',
  'America/Danmarkshavn' = 'America/Danmarkshavn',
  'Atlantic/Canary' = 'Atlantic/Canary',
  'Atlantic/Faroe' = 'Atlantic/Faroe',
  'Atlantic/Reykjavik' = 'Atlantic/Reykjavik',
  'Etc/GMT' = 'Etc/GMT',
  'Europe/Dublin' = 'Europe/Dublin',
  'Europe/Lisbon' = 'Europe/Lisbon',
  'Europe/London' = 'Europe/London',
  'Africa/Algiers' = 'Africa/Algiers',
  'Africa/Ceuta' = 'Africa/Ceuta',
  'Africa/Lagos' = 'Africa/Lagos',
  'Africa/Ndjamena' = 'Africa/Ndjamena',
  'Africa/Tunis' = 'Africa/Tunis',
  'Africa/Windhoek' = 'Africa/Windhoek',
  'Europe/Amsterdam' = 'Europe/Amsterdam',
  'Europe/Andorra' = 'Europe/Andorra',
  'Europe/Belgrade' = 'Europe/Belgrade',
  'Europe/Berlin' = 'Europe/Berlin',
  'Europe/Brussels' = 'Europe/Brussels',
  'Europe/Budapest' = 'Europe/Budapest',
  'Europe/Copenhagen' = 'Europe/Copenhagen',
  'Europe/Gibraltar' = 'Europe/Gibraltar',
  'Europe/Luxembourg' = 'Europe/Luxembourg',
  'Europe/Madrid' = 'Europe/Madrid',
  'Europe/Malta' = 'Europe/Malta',
  'Europe/Monaco' = 'Europe/Monaco',
  'Europe/Oslo' = 'Europe/Oslo',
  'Europe/Paris' = 'Europe/Paris',
  'Europe/Prague' = 'Europe/Prague',
  'Europe/Rome' = 'Europe/Rome',
  'Europe/Stockholm' = 'Europe/Stockholm',
  'Europe/Tirane' = 'Europe/Tirane',
  'Europe/Vienna' = 'Europe/Vienna',
  'Europe/Warsaw' = 'Europe/Warsaw',
  'Europe/Zurich' = 'Europe/Zurich',
  'Africa/Cairo' = 'Africa/Cairo',
  'Africa/Johannesburg' = 'Africa/Johannesburg',
  'Africa/Maputo' = 'Africa/Maputo',
  'Africa/Tripoli' = 'Africa/Tripoli',
  'Asia/Amman' = 'Asia/Amman',
  'Asia/Beirut' = 'Asia/Beirut',
  'Asia/Damascus' = 'Asia/Damascus',
  'Asia/Gaza' = 'Asia/Gaza',
  'Asia/Jerusalem' = 'Asia/Jerusalem',
  'Asia/Nicosia' = 'Asia/Nicosia',
  'Europe/Athens' = 'Europe/Athens',
  'Europe/Bucharest' = 'Europe/Bucharest',
  'Europe/Chisinau' = 'Europe/Chisinau',
  'Europe/Helsinki' = 'Europe/Helsinki',
  'Europe/Istanbul' = 'Europe/Istanbul',
  'Europe/Kaliningrad' = 'Europe/Kaliningrad',
  'Europe/Kiev' = 'Europe/Kiev',
  'Europe/Riga' = 'Europe/Riga',
  'Europe/Sofia' = 'Europe/Sofia',
  'Europe/Tallinn' = 'Europe/Tallinn',
  'Europe/Vilnius' = 'Europe/Vilnius',
  'Africa/Khartoum' = 'Africa/Khartoum',
  'Africa/Nairobi' = 'Africa/Nairobi',
  'Antarctica/Syowa' = 'Antarctica/Syowa',
  'Asia/Baghdad' = 'Asia/Baghdad',
  'Asia/Qatar' = 'Asia/Qatar',
  'Asia/Riyadh' = 'Asia/Riyadh',
  'Europe/Minsk' = 'Europe/Minsk',
  'Europe/Moscow' = 'Europe/Moscow',
  'Asia/Tehran' = 'Asia/Tehran',
  'Asia/Baku' = 'Asia/Baku',
  'Asia/Dubai' = 'Asia/Dubai',
  'Asia/Tbilisi' = 'Asia/Tbilisi',
  'Asia/Yerevan' = 'Asia/Yerevan',
  'Europe/Samara' = 'Europe/Samara',
  'Indian/Mahe' = 'Indian/Mahe',
  'Indian/Mauritius' = 'Indian/Mauritius',
  'Indian/Reunion' = 'Indian/Reunion',
  'Asia/Kabul' = 'Asia/Kabul',
  'Antarctica/Mawson' = 'Antarctica/Mawson',
  'Asia/Aqtau' = 'Asia/Aqtau',
  'Asia/Aqtobe' = 'Asia/Aqtobe',
  'Asia/Ashgabat' = 'Asia/Ashgabat',
  'Asia/Dushanbe' = 'Asia/Dushanbe',
  'Asia/Karachi' = 'Asia/Karachi',
  'Asia/Tashkent' = 'Asia/Tashkent',
  'Asia/Yekaterinburg' = 'Asia/Yekaterinburg',
  'Indian/Kerguelen' = 'Indian/Kerguelen',
  'Indian/Maldives' = 'Indian/Maldives',
  'Asia/Calcutta' = 'Asia/Calcutta',
  'Asia/Colombo' = 'Asia/Colombo',
  'Asia/Katmandu' = 'Asia/Katmandu',
  'Antarctica/Vostok' = 'Antarctica/Vostok',
  'Asia/Almaty' = 'Asia/Almaty',
  'Asia/Bishkek' = 'Asia/Bishkek',
  'Asia/Dhaka' = 'Asia/Dhaka',
  'Asia/Omsk' = 'Asia/Omsk',
  'Asia/Thimphu' = 'Asia/Thimphu',
  'Indian/Chagos' = 'Indian/Chagos',
  'Asia/Rangoon' = 'Asia/Rangoon',
  'Indian/Cocos' = 'Indian/Cocos',
  'Antarctica/Davis' = 'Antarctica/Davis',
  'Asia/Bangkok' = 'Asia/Bangkok',
  'Asia/Hovd' = 'Asia/Hovd',
  'Asia/Jakarta' = 'Asia/Jakarta',
  'Asia/Krasnoyarsk' = 'Asia/Krasnoyarsk',
  'Asia/Saigon' = 'Asia/Saigon',
  'Asia/Ho_Chi_Minh' = 'Asia/Ho_Chi_Minh',
  'Indian/Christmas' = 'Indian/Christmas',
  'Antarctica/Casey' = 'Antarctica/Casey',
  'Asia/Brunei' = 'Asia/Brunei',
  'Asia/Choibalsan' = 'Asia/Choibalsan',
  'Asia/Hong_Kong' = 'Asia/Hong_Kong',
  'Asia/Irkutsk' = 'Asia/Irkutsk',
  'Asia/Kuala_Lumpur' = 'Asia/Kuala_Lumpur',
  'Asia/Macau' = 'Asia/Macau',
  'Asia/Makassar' = 'Asia/Makassar',
  'Asia/Manila' = 'Asia/Manila',
  'Asia/Shanghai' = 'Asia/Shanghai',
  'Asia/Singapore' = 'Asia/Singapore',
  'Asia/Taipei' = 'Asia/Taipei',
  'Asia/Ulaanbaatar' = 'Asia/Ulaanbaatar',
  'Australia/Perth' = 'Australia/Perth',
  'Asia/Pyongyang' = 'Asia/Pyongyang',
  'Asia/Dili' = 'Asia/Dili',
  'Asia/Jayapura' = 'Asia/Jayapura',
  'Asia/Seoul' = 'Asia/Seoul',
  'Asia/Tokyo' = 'Asia/Tokyo',
  'Asia/Yakutsk' = 'Asia/Yakutsk',
  'Pacific/Palau' = 'Pacific/Palau',
  'Australia/Adelaide' = 'Australia/Adelaide',
  'Australia/Darwin' = 'Australia/Darwin',
  'Antarctica/DumontDUrville' = 'Antarctica/DumontDUrville',
  'Asia/Magadan' = 'Asia/Magadan',
  'Asia/Vladivostok' = 'Asia/Vladivostok',
  'Australia/Brisbane' = 'Australia/Brisbane',
  'Australia/Hobart' = 'Australia/Hobart',
  'Australia/Sydney' = 'Australia/Sydney',
  'Pacific/Chuuk' = 'Pacific/Chuuk',
  'Pacific/Guam' = 'Pacific/Guam',
  'Pacific/Port_Moresby' = 'Pacific/Port_Moresby',
  'Pacific/Efate' = 'Pacific/Efate',
  'Pacific/Guadalcanal' = 'Pacific/Guadalcanal',
  'Pacific/Kosrae' = 'Pacific/Kosrae',
  'Pacific/Norfolk' = 'Pacific/Norfolk',
  'Pacific/Noumea' = 'Pacific/Noumea',
  'Pacific/Pohnpei' = 'Pacific/Pohnpei',
  'Asia/Kamchatka' = 'Asia/Kamchatka',
  'Pacific/Auckland' = 'Pacific/Auckland',
  'Pacific/Fiji' = 'Pacific/Fiji',
  'Pacific/Funafuti' = 'Pacific/Funafuti',
  'Pacific/Kwajalein' = 'Pacific/Kwajalein',
  'Pacific/Majuro' = 'Pacific/Majuro',
  'Pacific/Nauru' = 'Pacific/Nauru',
  'Pacific/Tarawa' = 'Pacific/Tarawa',
  'Pacific/Wake' = 'Pacific/Wake',
  'Pacific/Wallis' = 'Pacific/Wallis',
  'Pacific/Apia' = 'Pacific/Apia',
  'Pacific/Enderbury' = 'Pacific/Enderbury',
  'Pacific/Fakaofo' = 'Pacific/Fakaofo',
  'Pacific/Tongatapu' = 'Pacific/Tongatapu',
  'Pacific/Kiritimati' = 'Pacific/Kiritimati',
}
